export default __webpack_public_path__ + "static/media/pushnotifications.6abff55a.svg";